import Styled from "styled-components";
import { Typography} from "@mui/material";

export const Heading = Styled(Typography)`
  font-family: 'Open Sans', sans-serif;
  font-weight: bold;
  text-decoration: underline;`